import React, {
  useCallback,
  useState,
  useContext,
} from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { getGeoData } from '../../../pages/Onboarding/Subscription/components/AccountCreation/utils';
import useRunOnInitialRender from '../../../hooks/useRunOnInitialRender';
import useComponentMounted from '../../../hooks/useComponentMounted';
import FirebaseContext from '../../../context/FirebaseContext';
import Container, { ErrorMessage } from '../styles';

const FormikPhoneInput = ({
  name,
  placeholder,
  className,
  label,
  isSmall,
  isDarkTheme,
}) => {
  const { 0: field, 2: { setValue } } = useField(name);
  const [defaultCountry, setDefaultCountry] = useState();
  const isComponentMountedRef = useComponentMounted();
  const { firebase: { remote } } = useContext(FirebaseContext);

  const getGeoDataOfUser = useCallback(async () => {
    const geoData = await getGeoData(remote);
    if (!!geoData && isComponentMountedRef.current) {
      setDefaultCountry(geoData.country_code);
    } else if (isComponentMountedRef.current) {
      setDefaultCountry('US');
    }
  }, [remote, isComponentMountedRef]);

  useRunOnInitialRender(() => {
    if (!field.value) {
      getGeoDataOfUser();
    }
  });

  const onPhoneValueChange = useCallback((value = '') => {
    setValue(value);
  }, [setValue]);

  return (
    <Container
      isSmall={isSmall}
      $isDarkTheme={isDarkTheme}
      $filled={!!field.value}
    >
      <div className={className}>
        <div className="input-wrapper">
          {!!label && <label htmlFor={name}>{label}</label>}
          <PhoneInput
            {...field}
            defaultCountry={defaultCountry}
            countryCallingCodeEditable={false}
            placeholder={placeholder}
            onChange={onPhoneValueChange}
            value={field.value}
          />
        </div>
        <ErrorMessage
          name={name}
          component="div"
          className="error-message"
        />
      </div>
    </Container>
  );
};

FormikPhoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  isSmall: PropTypes.bool,
  label: PropTypes.string,
  isDarkTheme: PropTypes.bool,
};

FormikPhoneInput.defaultProps = {
  placeholder: 'Phone number',
  className: 'FormikPhoneInput',
  label: '',
  isSmall: false,
  isDarkTheme: false,
};

export default FormikPhoneInput;
